import { useEffect } from 'react';
import { TextField, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
// utilities
import { 
  setFormData,
  resetFormData,
  setRoleType,
} from "../../../../features/roleStepper/roleStepperSlice";
import { InputBox } from '../../../FormComponent';
// componentss

const RoleNameForm = () => {
  const dispatch = useDispatch();

  const roleType = useSelector((state) => state.roleStepper.roleType); 
  const roleData = useSelector((state) => state.roleStepper.formData);
  const formErrors = useSelector((state) => state.roleStepper.formErrors); 

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(setFormData({
      ...roleData,
      [name]: value,
      type: roleType
    }));

    // Clear error for the field being edited
    if (formErrors[name]) {
      dispatch(setFormData({
        ...roleData,
        [name]: value,
        type: roleType
      }));
    }
  };

  useEffect(() => {
    // Reset form data when the component mounts
  }, [dispatch]);

  return (
    <Box component="form" sx={{ display: 'flex', flexDirection: 'column', maxWidth: "60%", margin: 'auto', padding: 2, gap: 2 }}>
      <InputBox 
        name="name"
        label="Role Name"
        required
        value={roleData.name}
        onChange={handleInputChange}
        error={formErrors.name ? (formErrors.nameMessage || "Role name is required") : ""} 
        helperText="Maximum 100 characters"
      />
      <InputBox 
        name="description"
        label="Role Description"
        required
        value={roleData.description}
        onChange={handleInputChange}
        error={formErrors.description ? (formErrors.descriptionMessage || "Role description is required") : ""} 
        helperText="Maximum 1000 characters"
      />
    </Box>
  );
};

export default RoleNameForm;
